var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashooLogoSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 270,
    viewBox: "0 0 471 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 135.252C0 213.981 57.1814 270 140.673 270C224.674 270 281.86 217.009 281.86 135.252C281.86 53.4951 224.169 0 140.673 0C57.1814 0 0 53.4951 0 135.252ZM188.749 135.252C188.749 183.197 171.538 206.411 141.178 206.411C110.818 206.411 93.1146 183.197 93.1146 135.252C93.1146 87.3086 110.818 63.5892 141.178 63.5892C171.033 63.5892 188.749 87.3086 188.749 135.252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.143 135.252C189.143 213.981 246.33 270 329.825 270C413.826 270 471 217.009 471 135.252C471 53.4951 413.321 0 329.825 0C246.33 0 189.143 53.4951 189.143 135.252ZM377.889 135.252C377.889 183.197 360.69 206.411 330.33 206.411C299.97 206.411 282.254 183.197 282.254 135.252C282.254 87.3086 299.97 63.5892 330.33 63.5892C360.185 63.5892 377.889 87.3086 377.889 135.252Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashooLogoSm);
export default __webpack_public_path__ + "static/media/cashoo-logo-sm.e4f9c7a88fe6ff0c4545e1d43851f699.svg";
export { ForwardRef as ReactComponent };